/** Primary brand color for store cart + store checkout UI chrome */
export const STORE_FLOW_PRIMARY_COLOR = '#191960';
export const STORE_FLOW_PRIMARY_HOVER_COLOR = '#252575';

/** Store Customization CTAs/toggle + Select Minimum selected pills */
export const STORE_FLOW_SELECTION_ACCENT_COLOR = '#4698EA';
export const STORE_FLOW_SELECTION_ACCENT_HOVER_COLOR = '#3B82F6';
export const STORE_FLOW_SELECTION_ACCENT_LIGHT_COLOR = '#F8FCFF';
export const STORE_FLOW_SELECTION_ACCENT_MUTED_COLOR = '#5AA2EC';
export const STORE_FLOW_SELECTION_ACCENT_BORDER_COLOR = '#B4D3F2';
export const STORE_FLOW_PRIMARY_BACKGROUND = '#F0F0F8';
export const STORE_FLOW_PRIMARY_BORDER = '#C8C8E0';

/** Secondary button (Preview Store, Go Back) */
export const STORE_FLOW_SECONDARY_BUTTON_BACKGROUND = '#F8FCFF';
export const STORE_FLOW_SECONDARY_BUTTON_BORDER = '#8DC5FC';
export const STORE_FLOW_SECONDARY_BUTTON_HOVER_BORDER = '#191960';

/** Shipping option selection — one-place (purple) / direct (pink) */
export const STORE_FLOW_SELECTION_PURPLE = '#8066F0';
export const STORE_FLOW_SELECTION_PURPLE_BACKGROUND = '#FBFAFF';
export const STORE_FLOW_SELECTION_PURPLE_BORDER = '#E1D9FF';
export const STORE_FLOW_SELECTION_PURPLE_ICON_FILL = '#F2EFFF';
export const STORE_FLOW_SELECTION_PINK = '#EB79C5';
export const STORE_FLOW_SELECTION_PINK_BACKGROUND = '#FFF8FD';
export const STORE_FLOW_SELECTION_PINK_BORDER = '#FDDBF2';
export const STORE_FLOW_SELECTION_PINK_ICON_FILL = '#FCEDF7';
export const STORE_FLOW_STEPPER_PINK = '#EB79C3';

/** Typography — store cart + store checkout */
export const STORE_FLOW_TITLE_FONT_FAMILY = 'Rethink Sans, sans-serif';
export const STORE_FLOW_BODY_FONT_FAMILY = 'Geist-Regular, Geist, sans-serif';

/** SF UI weight → Geist weight mapping (for reference / inline styles) */
export const STORE_FLOW_FONT_WEIGHT_MAP = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  heavy: 800,
} as const;
